import { PermissionsEnum } from "@/auth/interfaces";
import { CustomTabPanel } from "@/erp/sale";
import { a11yProps, EstadoProspectoEnum, hasPermission, ROUTER_PATHS, sizeTab, useCheckPermissions } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TableProspectoPymes from "../../shared/componente/table_prospecto_pymes/TableProspectoPymes";

export default function ProspectoPymesPage() {

  useCheckPermissions(PermissionsEnum.api_view_prospectopymes);

  const [valueTab, setValueTab] = useState(0);

  return <SingleTableBoxScene title={"Prospecto PYMES"}
    py={2}
    enableRedirect={hasPermission(PermissionsEnum.api_view_prospectopymes)}
    urlRedirect={hasPermission(PermissionsEnum.api_view_prospectopymes) ? ROUTER_PATHS.ventasPymes.prospectoCreateNav : undefined}
    visibleReport={true}
  >
    <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
      <Tabs
        value={valueTab}
        onChange={(_event: React.SyntheticEvent, newValue: number) => {
          setValueTab(newValue);
        }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="scrollable force tabs preventa"
      >
        <Tab label={'Prospectos'} {...a11yProps(0)} />
        <Tab label={'Finalizado'} {...a11yProps(1)} />
        <Tab label={'Fallido'} {...a11yProps(2)} />
      </Tabs>
    </Box>
    <CustomTabPanel value={valueTab} index={0}>
      <TableProspectoPymes
        estado_prospecto={EstadoProspectoEnum.EN_ESPERA}
        enabled_actions={true}
      />
    </CustomTabPanel>
    <CustomTabPanel value={valueTab} index={1}>
      <TableProspectoPymes
        estado_prospecto={EstadoProspectoEnum.FINALIZADO}
        enabled_actions={false}
      />
    </CustomTabPanel>
    <CustomTabPanel value={valueTab} index={2}>
      <TableProspectoPymes
        estado_prospecto={EstadoProspectoEnum.CANCELADO}
        enabled_actions={false}
      />
    </CustomTabPanel>
  </SingleTableBoxScene >

}